module.exports = __webpack_public_path__ + "static/media/Tiktok_w.f898008c.png";